/* @flow */
// typecheck: ignore file
import React from 'react';
import Toast from 'components/Toast.jsx';
import Notice from 'components/Notice.jsx';

const SuccessToast = (props: {children?: any}) => (
  <Toast>
    <Notice color="shamrock" glyph="check">
      {props.children}
    </Notice>
  </Toast>
);

export default SuccessToast;



// WEBPACK FOOTER //
// ./src/components/SuccessToast.jsx